import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Mot de passe réinitialisé. Vous pouvez vous connecter.");
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0D14] p-6">
      <div className="w-full max-w-sm animate-fade-up">
        <h2 className="font-heading text-2xl font-bold text-[#F8FAFC] mb-2">Nouveau mot de passe</h2>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-[#94A3B8]">Nouveau mot de passe</Label>
            <Input
              data-testid="reset-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
              className="mt-1.5 bg-[#182232] border-[#2A364F] text-[#F8FAFC]"
            />
          </div>
          {error && <div className="text-sm text-[#EF4444]">{error}</div>}
          <Button data-testid="reset-submit-button" type="submit" disabled={loading || !token} className="w-full bg-[#3B82F6] hover:bg-[#2563EB] text-white">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Réinitialiser"}
          </Button>
        </form>
        <Link to="/login" className="mt-6 inline-flex items-center gap-2 text-sm text-[#3B82F6] hover:underline">
          <ArrowLeft className="w-4 h-4" /> Retour à la connexion
        </Link>
      </div>
    </div>
  );
}
